// Entitycore
import { BucketBuilder } from "../../legacyPlanner/bucket/BucketBuilder";
/** Class to handle serialization/deserialization for Basic buckets */ export class BucketSerializationHandler {
    /** serialize to IGraphBucketResource */ toSerializable(key, value) {
        return value.toGraphSerializable();
    }
    /** build IBucket from IGraphBucketResource */ fromSerializable(key, serializableValue) {
        return new BucketBuilder().fromGraphResource(serializableValue).build();
    }
}
